var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEndToEndDev(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_108_618)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.0422 67.4714H178.989C178.989 68.1385 178.989 68.7103 178.989 69.2928C178.989 99.1445 178.989 128.986 178.989 158.837C178.989 169.077 172.977 176.649 163.292 178.629C161.863 178.926 160.37 178.968 158.91 178.968C122.317 178.989 85.7249 178.989 49.1326 178.968C39.0027 178.968 31.4662 173.006 29.4233 163.359C29.1269 161.94 29.0634 160.436 29.0634 158.975C29.0422 129.017 29.0528 99.0598 29.0528 69.1022C29.0528 68.615 29.0528 68.1279 29.0528 67.4502L29.0422 67.4714ZM117.755 90.4188C117.734 87.5067 115.966 85.3994 113.5 84.9652C110.748 84.4781 108.44 85.9183 107.551 88.7986C104.598 98.3397 101.687 107.881 98.7656 117.433C96.0241 126.412 93.2508 135.382 90.5622 144.372C89.6308 147.475 91.4937 150.355 94.6375 150.98C97.3049 151.499 99.6865 149.836 100.65 146.712C106.217 128.562 111.775 110.401 117.332 92.2508C117.554 91.5307 117.681 90.7788 117.766 90.4294L117.755 90.4188ZM68.3232 117.93C72.9276 113.334 77.3733 108.929 81.7873 104.492C84.2007 102.078 84.2959 99.0068 82.0942 96.836C79.9984 94.7711 76.77 94.8452 74.5048 97.1007C68.8312 102.745 63.1683 108.4 57.5265 114.076C55.2295 116.384 55.2613 119.445 57.5265 121.785C58.7755 123.077 60.0669 124.326 61.3371 125.597C65.8039 130.066 70.2602 134.535 74.7377 138.993C76.3148 140.56 78.2201 141.005 80.2948 140.221C82.2318 139.49 83.3539 137.997 83.6185 135.943C83.8619 134.058 83.0363 132.586 81.7343 131.294C77.2887 126.889 72.8747 122.463 68.3232 117.93ZM139.687 117.877C139.285 118.301 139.031 118.587 138.766 118.852C134.532 123.087 130.277 127.302 126.075 131.57C123.841 133.825 123.82 136.854 125.906 139.003C127.959 141.121 131.124 141.153 133.347 138.961C139.147 133.211 144.927 127.44 150.674 121.637C152.717 119.572 152.834 116.448 150.844 114.415C145.011 108.463 139.126 102.576 133.177 96.7407C131.082 94.6863 127.811 94.9087 125.842 96.9843C123.831 99.0916 123.894 102.078 126.085 104.291C130.574 108.813 135.104 113.292 139.708 117.877H139.687Z",
    fill: "url(#paint0_linear_108_618)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.894 56.8395H29.0528C29.2222 51.9048 28.4389 47.0019 30.0055 42.2367C32.6623 34.0933 39.9342 29.021 48.9632 29.0104C68.3443 28.9892 87.7361 29.0104 107.117 29.0104C124.434 29.0104 141.751 28.9998 159.058 29.0104C167.409 29.021 173.591 32.6955 177.19 40.2776C178.121 42.2367 178.64 44.5134 178.82 46.6948C179.085 50.0305 178.894 53.4086 178.894 56.8395Z",
    fill: "url(#paint1_linear_108_618)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_108_618",
    x1: 104.016,
    y1: 67.4502,
    x2: 104.016,
    y2: 178.984,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_108_618",
    x1: 103.982,
    y1: 29.001,
    x2: 103.982,
    y2: 56.8395,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_108_618"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 150,
    height: 150,
    fill: "white",
    transform: "translate(29 29)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEndToEndDev);
export default __webpack_public_path__ + "static/media/End-to-End_Dev.3f5abd4d33243ff729471d394dd4b964.svg";
export { ForwardRef as ReactComponent };